export const schema = {
  id: 'tmv-maintenance-checklist',
  name: 'Thermostatic Mixing Valve (TMV2 / TMV3) Commissioning & Maintenance Checklist',
  description: 'TMV2 Scheme (Domestic/Commercial) and TMV3 Scheme (NHS D08 Healthcare) compliance testing record',
  category: 'Plumbing',
  sections: [
    {
      id: 'testerDetails',
      title: '1. Testing Engineer & Company Details',
      fields: [
        { id: 'companyName', label: 'Company Name', type: 'text', required: true },
        { id: 'engineerName', label: 'Engineer Name', type: 'text', required: true },
        { id: 'telephone', label: 'Telephone Number', type: 'tel', required: true },
        { id: 'qualifications', label: 'Competency / Card ID', type: 'text' }
      ]
    },
    {
      id: 'premisesDetails',
      title: '2. Premises & Site Location',
      fields: [
        { id: 'siteName', label: 'Site / Facility Name', type: 'text', required: true },
        { id: 'siteType', label: 'Premises Type', type: 'select', options: ['NHS / Healthcare Hospital (TMV3 / D08)', 'Care Home / Nursing Facility (TMV3)', 'School / Nursery (TMV2/TMV3)', 'Commercial Hotel / Gym / Public Facility', 'Domestic Residential (TMV2)'], required: true },
        { id: 'siteAddress', label: 'Site Address', type: 'textarea', required: true },
        { id: 'postCode', label: 'Postcode', type: 'text', required: true },
        { id: 'testDate', label: 'Date of Inspection', type: 'date', required: true }
      ]
    },
    {
      id: 'valveSpecification',
      title: '3. Valve Identification & Application Designation',
      fields: [
        { id: 'valveTagNumber', label: 'Valve Asset ID / Tag No.', type: 'text', required: true },
        { id: 'valveLocation', label: 'Room / Outlet Location', type: 'text', required: true },
        { id: 'tmvScheme', label: 'TMV Scheme Type', type: 'select', options: ['TMV3 (Healthcare / High Risk)', 'TMV2 (Commercial / Domestic)'], required: true },
        { id: 'applicationKey', label: 'Designated Application', type: 'select', options: ['tmv2_washbasin', 'tmv2_shower', 'tmv2_bath_unassisted', 'tmv3_bidet', 'tmv3_washbasin', 'tmv3_shower', 'tmv3_bath_assisted'], required: true },
        { id: 'valveMakeModel', label: 'Valve Make & Model', type: 'text', required: true },
        { id: 'valveSizeMm', label: 'Valve Size (mm)', type: 'select', options: ['15mm', '22mm', '28mm'], required: true }
      ]
    },
    {
      id: 'temperatureReadings',
      title: '4. Dynamic Temperature & Pressure Measurements',
      fields: [
        { id: 'hotSupplyTempC', label: 'Hot Water Supply Temp (°C - min 52°C/55°C)', type: 'number', required: true },
        { id: 'coldSupplyTempC', label: 'Cold Water Supply Temp (°C - max 20°C)', type: 'number', required: true },
        { id: 'hotSupplyDynamicPressureBar', label: 'Hot Supply Dynamic Pressure (Bar)', type: 'number' },
        { id: 'coldSupplyDynamicPressureBar', label: 'Cold Supply Dynamic Pressure (Bar)', type: 'number' },
        { id: 'setMixedOutletTempC', label: 'Initial Mixed Outlet Temperature (°C)', type: 'number', required: true },
        { id: 'maxAllowableTempC', label: 'Statutory Max Permitted Outlet Temp (°C)', type: 'number', required: true }
      ]
    },
    {
      id: 'failSafeTesting',
      title: '5. Cold Water Isolation Fail-Safe Shut-off Test',
      fields: [
        { id: 'failSafeResponseTimeSec', label: 'Time to Full Shut-off upon Cold Isolation (Seconds)', type: 'number', required: true },
        { id: 'residualSeepageMl', label: 'Residual Seepage Volume during 30s (ml - max 120ml)', type: 'number', required: true },
        { id: 'failSafeResult', label: 'Fail-Safe Test Verdict', type: 'select', options: ['Pass (Immediate Shut-off <= 1.5s)', 'Failed (Exceeded Shut-off Time / Seepage)', 'N/A'], required: true },
        { id: 'restoredMixedTempC', label: 'Restored Mixed Temperature after Cold Re-opened (°C)', type: 'number', required: true },
        { id: 'tempStabilityWithin2C', label: 'Restored Mixed Temp within ±2°C of Set Temp?', type: 'select', options: ['Yes', 'No'], required: true }
      ]
    },
    {
      id: 'mechanicalServicing',
      title: '6. Strainer Cleaning, Descaling & Check Valves',
      fields: [
        { id: 'strainersCleaned', label: 'Inlet Strainers / Filters Inspected & Cleaned?', type: 'select', options: ['Yes', 'No', 'Replaced'], required: true },
        { id: 'checkValvesTested', label: 'Integral Non-Return (Check) Valves Tested for Backflow?', type: 'select', options: ['Pass - Sound', 'Failed - Passing', 'Replaced'], required: true },
        { id: 'descalingRequired', label: 'Thermostatic Cartridge Descaled?', type: 'select', options: ['Yes', 'No - Clean'], required: true },
        { id: 'isolationValvesOperating', label: 'Service Isolation Ball Valves Operating Freely?', type: 'select', options: ['Yes', 'No'], required: true }
      ]
    },
    {
      id: 'summaryAndDeclarations',
      title: '7. Overall Assessment & Sign-Off',
      fields: [
        { id: 'overallResult', label: 'Overall Valve Compliance Assessment', type: 'select', options: ['SATISFACTORY / COMPLIANT', 'UNSATISFACTORY / ISOLATED (DEFECTIVE)'], required: true },
        { id: 'remedialActionNotes', label: 'Remedial Action Taken / Defect Observations', type: 'textarea' },
        { id: 'nextInspectionDue', label: 'Next Periodic TMV Test Due (6/12 Months)', type: 'date', required: true },
        { id: 'engineerSignature', label: 'Testing Engineer Signature', type: 'signature', required: true },
        { id: 'clientSignature', label: 'Duty Holder / Client Signature', type: 'signature', required: true }
      ]
    }
  ]
};

export default schema;
